import { type FC } from 'react';

import { BackgroundWrapper } from '@/components/ui/BackgroundWrapper/BackgroundWrapper';

import css from './styles.module.scss';

const EndPeriodBackground: FC = () => {
  return (
    <BackgroundWrapper className={css.endPeriod}>
      <div className={css.endPeriodImage}></div>
      <span className={css.ellipse}></span>
    </BackgroundWrapper>
  );
};

export { EndPeriodBackground };
